import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { DeviceBreakdown } from '../../../../models/patch-management.models';

@Component({
  selector: 'app-device-compliance-bars',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './device-compliance-bars.component.html',
  styleUrls: ['./device-compliance-bars.component.scss'],
})
export class DeviceComplianceBarsComponent {
  @Input({ required: true }) devices: DeviceBreakdown[] = [];
  @Input() activeDevice: string | null = null;
  @Output() deviceSelect = new EventEmitter<string | null>();

  /** Raw `100 - pct` re-introduces float noise (e.g. 15.099999999999994) — round it here instead */
  missPct(pct: number): number {
    return Math.round((100 - pct) * 10) / 10;
  }

  tooltip(d: DeviceBreakdown): string {
    return `Installed ${d.pct}% · Missing ${this.missPct(d.pct)}%`;
  }

  select(name: string): void {
    this.deviceSelect.emit(this.activeDevice === name ? null : name);
  }
}
